<template>
    <v-card v-ripple="!readonly" flat tile class="pa-3">
        <v-card-text class="pa-0">
            <v-row align="center">
                <v-col v-if="!readonly" cols="1" align="left" class="pl-0">
                    <v-icon @contextmenu.prevent="() => {return false}" class="handle-item">mdi-drag-vertical
                    </v-icon>
                </v-col>
                <exercise-img-video :is-second-dialog="isSecondDialog" :video="exerciseVideo" :img="exerciseImg"/>
                <v-col :cols="readonly ? '9' : '7'" class="px-2" @click="toggleExpand">
                    <v-row no-gutters>
                        <v-col cols="12" class="exercise-name text-truncate">
                            {{ exercise.name }}
                        </v-col>
                        <v-col cols="12" v-if="!noConfigYet" class="exercise-repeat">
                            {{ exerciseSets }} {{ exercise.eachSide ? `| ${$t('exercises.each_side')}` : '' }}
                        </v-col>
                        <v-col cols="12" v-else class="exercise-error">
                            {{ $t('exercises.no_config_exercise_yet') }}
                            <v-icon color="error" size="15">mdi-gesture-tap</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2" align="right" v-if="!readonly">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-on="on">
                                <v-icon>mdi-dots-horizontal</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item dense link @click.prevent="onClickChange">
                                <v-list-item-title>
                                    {{ $t('common.change') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item dense link @click.prevent="onClickDuplicate">
                                <v-list-item-title>
                                    {{ $t('common.duplicate') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item dense link @click.prevent="onClickDelete">
                                <v-list-item-title>
                                    {{ $t('common.delete') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text class="px-0" v-show="expand">
            <simple-board :category-exercise="categoryExercise" :default-config="exerciseConfig" :has-time="!!exercise.hasTime"
                          @change="onConfigChange" @hide="toggleExpand" @click:rest="$emit('click:rest')"/>
        </v-card-text>
    </v-card>
</template>

<script>
import {randomString} from "@/utils/Common";
import SimpleBoard from "@/components/coach/routines/SimpleBoard";
import ExerciseImgVideo from "@/components/common/routines/ExerciseImgVideo";

export default {
    name: "BlockExerciseCard",
    components: {ExerciseImgVideo, SimpleBoard},
    props: {
        exercise: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        isSecondDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            expand: false,
            dataSet: null,
        }
    },
    methods: {
        toggleExpand() {
            const vm = this
            if (vm.readonly) {
                return vm.$emit('click:exercise', vm.exercise)
            }
            vm.expand = !vm.expand
        },
        onClickDelete() {
            const vm = this
            vm.$emit('click:delete')
        },
        onClickDuplicate() {
            const vm = this
            let template = JSON.parse(JSON.stringify(vm.exercise))
            template.uid = randomString()
            vm.$emit('click:duplicate', template)
        },
        onConfigChange(config) {
            const vm = this
            vm.$emit('change:config', config)
        },
        onClickChange() {
            const vm = this
            let template = JSON.parse(JSON.stringify(vm.exercise))
            template.uid = randomString()
            vm.$emit('click:change', template)
        },
    },
    computed: {
        exerciseImg() {
            const vm = this
            return vm.exercise.img || (vm.exercise.video && vm.exercise.video.thumb) || require(`@/assets/img/logo.png`)
        },
        exerciseVideo() {
            const vm = this
            return vm.exercise.video && vm.exercise.video.url || null
        },
        sets() {
            const vm = this
            return vm.exercise && vm.exercise.config && vm.exercise.config.sets || []
        },
        exerciseConfig() {
            const vm = this
            return vm.exercise && vm.exercise.config || null
        },
        noConfigYet() {
            const vm = this
            return vm.sets.length === 0
        },
        categoryExercise() {
            const vm = this
            return vm.exercise && vm.exercise.categories && vm.exercise.categories[0] || null
        },
        exerciseSets() {
            const vm = this
            let quantitySets = vm.sets.length
            if (quantitySets === 0) return vm.$t('common.not_available_short')
            let type = vm.$t(`exercises.${vm.sets[0].data[0].short_name}`)

            let result = ''

            if (quantitySets === 1) {
                result = `${quantitySets}x${vm.sets[0].data[0].value}${type}`
            } else {
                let values = []
                let current = null
                let sameValue = true
                vm.sets.forEach(set => {
                    if (!current) current = set.data[0].value
                    values.push(set.data[0].value)
                    if (current !== set.data[0].value) sameValue = false
                    current = set.data[0].value
                })

                if (sameValue) {
                    result = `${quantitySets}x${values[0]}${type}`
                } else {
                    result = `${quantitySets}x${values.join(`${type},`)}${type}`
                }
            }
            return result
        },
    },
}
</script>

<style scoped>
.exercise-img {
    background-position: 50% 50%;
    background-size: cover;
    height: 60px;
}

.exercise-name {
    font-size: 15px;
    color: #333333;
}

.exercise-category {
    font-size: 11px;
    color: #707070;
    line-height: 12px;
}

.exercise-repeat {
    font-size: 11px;
    color: #707070;
}

.exercise-error {
    font-size: 11px;
    color: var(--v-error-base);
}

.exercise-equipments {
    font-size: 11px;
    color: #707070;
}

</style>